import { NAV, type NavGroup, type NavItem } from './nav';
import { SCREEN_META, type ScreenMeta } from './screens.meta';

// Route → inventory screen (title key, type, highlighted nav item). SCREEN_META is generated by scripts/gen-screens.mjs.
export function screenFor(pathname: string): ScreenMeta | undefined {
  let p = pathname.replace(/^\/+|\/+$/g, '');
  if (p.startsWith('t/')) p = 'inv/tag';
  else if (p === 'scan' || p.startsWith('scan/')) p = 'inv/scan';
  const exact = SCREEN_META[p];
  if (exact) return exact;
  const cut = p.lastIndexOf('/');
  return cut > 0 ? SCREEN_META[p.slice(0, cut)] : undefined;
}

/** Nav route ('/inv/issues') to highlight for a pathname — forms highlight their list (inventory `parent`). */
export function activeNavRoute(pathname: string): string {
  const m = screenFor(pathname);
  return m ? `/${m.nav}` : pathname;
}

export interface NavHit {
  group: NavGroup;
  item: NavItem;
}

export function findNavItem(route: string): NavHit | undefined {
  for (const group of NAV) {
    const item = group.items.find((i) => i.route === route);
    if (item) return { group, item };
  }
  return undefined;
}
